import * as z from 'zod'
import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import { useGTMFetchErrorHandling } from './useGTMFetchErrorHandling'
import { GTM_API_LINK, gtmFetcher, gtmSWRErrorHandler } from 'lib/gtm'

const schema = z.object({
	tag: z.array(z.object({ name: z.string() })).optional(),
})

type TagsData = z.infer<typeof schema>

export function useGTMTags(
	accountId: string | null,
	containerId: string | null,
	workspaceId: string | null,
	options?: SWRConfiguration,
) {
	const shouldFetch = Boolean(accountId && containerId && workspaceId)
	const tagsFetcher = (url: string) => gtmFetcher({ url, schema })
	const { data, mutate, error } = useSWR<TagsData>(
		shouldFetch
			? `${GTM_API_LINK}/accounts/${accountId}/containers/${containerId}/workspaces/${workspaceId}/tags`
			: null,
		tagsFetcher,
		{
			...options,
			revalidateIfStale: false,
			keepPreviousData: true,
			onErrorRetry(_error, key, config, revalidate, revalidateOpts) {
				gtmSWRErrorHandler(_error, revalidate, revalidateOpts)
			},
		},
	)

	useGTMFetchErrorHandling(error)

	return {
		tags: data ? data.tag ?? [] : null,
		mutateTags: mutate,
	}
}
